import { Injectable } from '@angular/core';

import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { FavouritesDashboardUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';

import { FixtureTab } from '../competition-list/competition.models';

export interface FavouritesState {
    upcoming?: string;
    competitions?: StringDictionary<string>;
    players?: StringDictionary<string>;
    events?: string;
}

export interface FavouritesSectionTabState {
    upcoming?: StringDictionary<number | undefined>;
    competitions?: StringDictionary<number | undefined>;
    players?: StringDictionary<number | undefined>;
    events?: StringDictionary<number | undefined>;
}

@Injectable({ providedIn: 'root' })
export class FavouritesStateService {
    private state: FavouritesState;
    private sectionTabState: FavouritesSectionTabState;

    constructor() {
        this.state = {};
        this.sectionTabState = {};
    }

    get(routeTab: keyof FavouritesState, sectionId?: string): string | undefined {
        if (sectionId) {
            return this.state[routeTab] && (this.state[routeTab] as StringDictionary<string>)[sectionId];
        }

        return this.state[routeTab] as string;
    }

    update(routeTab: keyof FavouritesState, sectionId: string, pillId?: string): void {
        if (pillId && (routeTab === FavouritesDashboardUrlParam.Competitions || routeTab === FavouritesDashboardUrlParam.Players)) {
            this.setStateForSection(routeTab, sectionId, pillId);
        } else {
            this.state[routeTab as 'events' | 'upcoming'] = sectionId;
        }
    }

    getSectionTabState(routeTab: keyof FavouritesState, sectionId: string): FixtureTab | undefined {
        return this.sectionTabState[routeTab] && (this.sectionTabState[routeTab] as any)?.[sectionId];
    }

    updateSectionTabState(routeTab: keyof FavouritesSectionTabState, sectionId: string, tab?: FixtureTab): void {
        const tabForSection: Record<string, FixtureTab | undefined> = {};
        tabForSection[sectionId] = tab;
        this.sectionTabState[routeTab] = tabForSection;
    }

    clear(): void {
        this.state = {};
        this.sectionTabState = {};
    }

    private setStateForSection(routeTab: keyof FavouritesState, sectionId: string, pillId: string): void {
        if (this.state[routeTab]) {
            (this.state[routeTab] as StringDictionary<string>)[sectionId] = pillId;
        } else {
            const sectionState: StringDictionary<string> = {};
            sectionState[sectionId] = pillId;
            (this.state[routeTab] as any as StringDictionary<string>) = sectionState;
        }
    }
}
